<div *ngIf="('LOCATIONS' | write) && !container.afterSalesRequest" class="ribbon">
  <button mat-icon-button (click)="onAdd()"><mat-icon>add</mat-icon></button>
</div>
<div *ngIf="container.afterSalesRequest">
  <app-request-form [mode]="creation ? Mode.edition : Mode.action" [object]="container.afterSalesRequest" (event)="onEvent($event)"></app-request-form>
</div>
